import { render, staticRenderFns } from "./Assicurati_body.vue?vue&type=template&id=116c15f3"
import script from "./Assicurati_body.vue?vue&type=script&lang=js"
export * from "./Assicurati_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports